(() => {
  const links = {
    '47122910413058': 'https://www.wayfair.com/outdoor/pdp/yunic-golf-putting-green-premium-nylon-golf-putting-mat-professional-training-mat-for-indoor-outdoor-ynic1013.html?piid=120146087',
    '47122910707970': 'https://www.wayfair.com/outdoor/pdp/yunic-16ft-dual-use-golf-putting-green-mat-with-center-hitting-mat-4-hole-indoor-outdoor-golf-training-mat-for-putting-full-swing-practice-ynic1036.html?piid=131401986',
    '47122909135106': 'https://www.wayfair.com/outdoor/pdp/yunic-golf-putting-green-indoor-outdoor-putting-mat-professional-training-mat-practice-putting-mat-style-us-map-ynic1006.html?piid=120146065'
  };
  function selected(root) {
    const el = root.querySelector('select[name="id"], input[name="id"]');
    return el && el.value;
  }
  function update() {
    document.querySelectorAll('[data-yunic-wayfair]').forEach(panel => {
      const root = panel.closest('.product-template__container');
      if (!root) return;
      const id = selected(root);
      if (id) panel.dataset.external = String(id === panel.dataset.wayfairVariant);
      const price = root.querySelector('.product-single__price');
      let label = root.querySelector('.yunic-wayfair-price');
      if (!label && price) {
        label = document.createElement('p');
        label.className = 'yunic-wayfair-price';
        label.textContent = panel.querySelector('.yunic-wayfair-price-text').textContent;
        price.before(label);
      }
      if (label) label.hidden = panel.dataset.external !== 'true';
    });
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  }
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', e => {
    const button = e.target.closest('button[name="add"], .btnAddToCart, .product-form__cart-submit');
    if (!button) { schedule(); return; }
    const root = button.closest('.product-template__container') || button.closest('form');
    const url = root && links[selected(root)];
    if (url) { e.preventDefault(); e.stopImmediatePropagation(); window.location.assign(url); }
  }, true);
  document.addEventListener('submit', e => {
    const root = e.target.closest('.product-template__container') || e.target;
    const url = links[selected(root)];
    if (url) { e.preventDefault(); e.stopImmediatePropagation(); window.location.assign(url); }
  }, true);
  new MutationObserver(records => {
    if (records.some(r => Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches?.('[data-yunic-wayfair]') || n.querySelector?.('[data-yunic-wayfair]'))))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('popstate', schedule);
  if (window.jQuery) window.jQuery(document).on('variantChange.yunicWayfair', schedule);
  update();
})();
